<template>
  <div class="table">
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item> <i class="el-icon-lx-cascades"></i> 自助工单 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="app-container">
        <div style="margin-bottom: 20px">
          <el-input v-model="listQuery.work_sn" placeholder="工单号" style="width: 200px; margin-right: 10px"></el-input>
          <el-input v-model="listQuery.account" placeholder="游戏账号" style="width: 200px; margin-right: 10px"></el-input>
          <el-input v-model="listQuery.server" placeholder="游戏服" style="width: 200px; margin-right: 10px"></el-input>
          <el-input v-model="listQuery.game_name" placeholder="游戏名称" style="width: 200px; margin-right: 10px"></el-input>
          <el-input v-model="listQuery.game_role_name" placeholder="角色名" style="width: 200px; margin-right: 10px"></el-input>
          <el-input v-model="listQuery.tel_num" placeholder="联系方式" style="width: 200px; margin-right: 10px"></el-input>
          <el-input v-model="listQuery.remarks" placeholder="备注" style="width: 200px; margin-right: 10px"></el-input>
          <el-select filterable v-model="listQuery.type_id" placeholder="问题类型" style="margin-right: 10px; margin-top: 10px">
            <el-option v-for="item in typeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select v-model="listQuery.deal_user_id" filterable placeholder="处理人" style="margin-right: 10px">
            <el-option v-for="item in dealData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select filterable v-model="listQuery.status" multiple placeholder="状态" style="margin-right: 10px">
            <el-option v-for="item in statusData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-date-picker
            v-model="listQuery.created_at"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['24:00:00']"
            style="margin-right: 10px"
          ></el-date-picker>
          <el-select filterable v-model="listQuery.degree" multiple placeholder="满意度" style="margin-right: 10px; margin-top: 10px">
            <el-option v-for="item in degreeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select filterable v-model="listQuery.quality_status" placeholder="质检状态" style="margin-right: 10px; margin-top: 10px">
            <el-option v-for="item in qualityTestingOptions" :key="item.index" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select filterable v-model="listQuery.quality_admin_id" placeholder="质检人" style="margin-right: 10px; margin-top: 10px">
            <el-option v-for="item in qualityPersonOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
          <el-select filterable v-model="listQuery.special_flag" placeholder="标记账号" style="margin-right: 10px; margin-top: 10px">
            <el-option v-for="item in special_flagOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>

          <br />
          <el-button class="filter-item" style="margin-right: 10px; margin-top: 10px" type="warning" @click="replyShow">批量回复</el-button>
          <el-button class="filter-item" style="margin-top: 10px" type="primary" @click="handleAutoReply">设置自动回复</el-button>
          <el-button class="filter-item" style="margin-top: 10px" type="primary" @click="handleUserSuggest">批量导入玩家建议</el-button>
          <el-button class="filter-item" style="float: right; margin-top: 10px" type="primary" @click="handleExport">导出</el-button>
          <el-button class="filter-item" style="float: right; margin-right: 10px; margin-top: 10px" type="warning" @click="handleResetSearch">重置</el-button>
          <el-button class="filter-item" style="float: right; margin-top: 10px" type="success" @click="handleMyFilter">我的工单</el-button>
          <el-button class="filter-item" style="float: right; margin-top: 10px" type="primary" icon="el-icon-search" @click="handleFilter">搜索</el-button>
        </div>

        <!-- 2021.03.03新增 工单总量显示 -->
        <p style="margin-top: 20px; margin-bottom: 20px">{{ `今日工作量：${current_number.today || 0}； 待处理：${current_number.waiting || 0}； 处理中：${current_number.dealing || 0}；` }}</p>

        <el-table
          border
          v-loading="listLoading"
          :data="tableData"
          ref="multipleTable"
          :default-sort="{ prop: 'created_at', order: 'descending' }"
          @sort-change="sortChange"
          @selection-change="handleSelectionChange"
          style="width: 100%"
          :cell-style="levelColor"
          min-height="200"
          max-height="1000"
        >
          <el-table-column type="selection" width="50" :selectable="checkboxT" />
          <el-table-column prop="work_sn" label="工单号" />
          <el-table-column prop="type" label="问题类型" />
          <el-table-column prop="account" label="游戏账号" />
          <el-table-column prop="device_system_text" label="系统" />
          <el-table-column prop="total_money" label="总充值" sortable @sort-method="sortChange"></el-table-column>
          <el-table-column prop="main_game_name" label="主游戏名称" width="90px;" />
          <el-table-column prop="game_name" label="游戏名称" />
          <el-table-column prop="server" label="游戏服" />
          <el-table-column prop="game_role_name" label="角色名" />
          <el-table-column prop="tel_num" label="联系方式" />
          <el-table-column prop="status_name" label="状态" width="70px;" />
          <el-table-column prop="deal_user" label="处理人" />
          <el-table-column prop="vip" label="vip客服" />
          <el-table-column prop="created_at" label="提交时间" sortable></el-table-column>
          <el-table-column prop="first_reply_duration" label="响应时长" sortable @sort-method="sortChange" />
          <el-table-column prop="admin_updated_at" label="管理员最后修改时间" sortable @sort-method="sortChange" />
          <el-table-column prop="remarks" label="备注" width="120px;" :show-overflow-tooltip="true" />
          <el-table-column prop="deal_time" label="处理时长" width="70px;" sortable />
          <el-table-column prop="quality_testing_person" label="质检人" />
          <el-table-column label="满意度" width="70px;">
            <template slot-scope="scope">
              <el-popover trigger="hover" placement="top">
                <p>游戏账号: {{ scope.row.account }}</p>
                <p>处理人: {{ scope.row.deal_user }}</p>
                <p>评价: {{ scope.row.degree }}</p>
                <p>详情: {{ scope.row.degree_content }}</p>
                <div slot="reference" class="name-wrapper">
                  <el-tag size="medium" v-if="scope.row.degree != null">{{ scope.row.degree }}</el-tag>
                  <el-tag size="medium" v-if="scope.row.degree == null">无</el-tag>
                </div>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="120" class-name="small-padding fixed-width">
            <template slot-scope="scope">
              <el-button type="primary" style="margin-right: 10px" size="mini" @click="singleSuggest(scope.row)">导入玩家建议</el-button>
              <el-button type="success" style="margin-right: 10px" size="mini" @click="handleUpdate(scope.row, 2)">查看</el-button>
              <el-button v-if="scope.row.deal_user_id == 0" type="success" style="margin-right: 10px" size="mini" @click="handleAddDeal(scope.row.id)">加入接管</el-button>
              <el-button v-if="scope.row.deal_user_id == scope.row.admin_id" type="danger" style="margin-right: 10px" size="mini" @click="handleDelDeal(scope.row.id)">取消接管</el-button>
              <el-button v-if="scope.row.show_assign_button" type="warning" style="margin-right: 10px" size="mini" @click="handoverQuestion(scope.row)">问题交接</el-button>
              <el-button v-if="withdraw_button" type="danger" style="margin-right: 10px" size="mini" @click="handleWithdraw(scope.row.work_sn)">撤回</el-button>
              <el-button v-if="scope.row.from == 2" style="margin-right: 10px" type="primary" size="mini" @click="addRemarks(scope.row)">添加备注</el-button>
              <el-button v-if="faq_button" class="filter-item" style="margin-right: 10px" size="mini" type="warning" @click="importFAQ(scope.row)">导入FAQ</el-button>
              <el-button v-if="delete_button" class="filter-item" style="margin-right: 10px" size="mini" type="danger" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="handleList" />

        <el-dialog title="工单删除" width="40%" center :visible.sync="delShow">
          <p>确认删除该工单？</p>
          <div slot="footer" class="dialog-footer">
            <el-button @click="delShow = false">取 消</el-button>
            <el-button type="primary" @click="sureDel">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="工单操作" center :visible.sync="look">
          <p>确认开始操作？</p>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeOperate">取 消</el-button>
            <el-button type="primary" @click="sureOperate">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="撤回" center :visible.sync="withdraw">
          <div style="text-align: center">确认“撤回”操作吗？</div>
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="sureRecall">是</el-button>
            <el-button @click="removeRecall">否</el-button>
          </span>
        </el-dialog>

        <el-dialog title="工单交接" width="40%" center :visible.sync="questionShow">
          <el-form style="margin-left: 20px">
            <el-form-item label="游戏名称" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="question.game_name" :disabled="true"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="创建时间" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="question.created_at" :disabled="true"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="历史接管人" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input v-model="question.deal_user" :disabled="true"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="问题详情" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-input type="textarea" v-model="question.details" :rows="8" :disabled="true"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="图片" :label-width="formLabelWidth">
              <el-col :span="16" class="closeImg">
                <el-image v-for="item in question.images" :key="item" :src="item" style="width: 100px; height: 100px; margin-right: 5px" :preview-src-list="question.images"> </el-image>
              </el-col>
            </el-form-item>
            <el-form-item label="接管人" :label-width="formLabelWidth" v-if="questionShow">
              <el-col :span="8">
                <singlePublisher v-model="noticeReceiver"></singlePublisher>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="questionShow = false">取 消</el-button>
            <el-button type="primary" @click="sureHandover">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="导入FAQ" width="60%" center :visible.sync="importFAQShow">
          <el-form style="margin-left: 20px">
            <el-form-item label="游戏名称" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-select v-model="faq.gameName" filterable placeholder="">
                  <el-option v-for="item in faqGameNameOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="问题类型" :label-width="formLabelWidth">
              <el-col :span="8">
                <el-select v-model="faq.questionType" filterable placeholder="">
                  <el-option v-for="item in faqQuestionTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-col>
            </el-form-item>

            <el-form-item label="问题详情" :label-width="formLabelWidth">
              <el-col :span="16">
                <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="faq.questionDetail"> </el-input>
              </el-col>
              <el-col style="margin-top: 10px">
                <el-upload
                  v-model="faq.questionImages"
                  :action="apiUrl"
                  drag
                  multiple
                  list-type="picture-card"
                  :file-list="getStableImageFileList('faq-question', questionDetailFiles)"
                  :headers="file_headers"
                  :on-preview="questionPreview"
                  :on-success="questionSuccess"
                  :on-remove="questionRemove"
                  :on-change="(file, fileList) => trackImageUpload('faq-question', file, fileList)"
                  :on-error="(error, file, fileList) => handleUploadError('faq-question', file, fileList)"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <el-dialog :visible.sync="dialogImageVisible">
                  <img width="100%" :src="dialogImageUrl" alt />
                </el-dialog>
              </el-col>
            </el-form-item>

            <el-form-item label="答案详情" :label-width="formLabelWidth">
              <el-col :span="20">
                <el-table ref="multipleTables" :data="answerOptions" tooltip-effect="dark" style="width: 100%" @selection-change="answerHandleSelectionChange">
                  <el-table-column label="" width="200" prop="item">
                    <template scope="scope">
                      <el-input type="textarea" :rows="6" placeholder="" v-model="scope.row.content"> </el-input>
                    </template>
                  </el-table-column>
                  <el-table-column label="" width="400" prop="item">
                    <template scope="scope">
                      <el-upload
                        v-model="scope.row.images"
                        :action="apiUrl"
                        drag
                        multiple
                        list-type="picture-card"
                        :file-list="getStableImageFileList(scope.row.uploadScope, scope.row.images)"
                        :headers="file_headers"
                        :on-preview="questionPreview"
                        :on-success="(response, file, fileList) => fileChange(response, file, fileList, scope.row)"
                        :on-remove="(file, fileList) => answerRemove(file, fileList, scope.row)"
                        :on-change="(file, fileList) => trackImageUpload(scope.row.uploadScope, file, fileList)"
                        :on-error="(error, file, fileList) => handleUploadError(scope.row.uploadScope, file, fileList)"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                    </template>
                  </el-table-column>

                  <el-table-column class="el-checkbox__inner" type="selection" width="100"> </el-table-column>
                </el-table>
              </el-col>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeImportFAQ">取 消</el-button>
            <el-button type="primary" @click="sureImportFAQ">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="工单回复" center :visible.sync="batchReply">
          <div style="display: flex; min-width: 400px">
            <div style="flex: 1; margin: 10px 20px">
              <div>
                <span style="display: inline-block; margin-bottom: 10px">批量回复</span>
                <el-input type="textarea" :rows="10" v-model="replyArea"> </el-input>
              </div>
            </div>

            <div style="flex: 1; margin: 10px 20px; height: 200px; box-sizing: border-box">
              <span style="display: inline-block; margin-bottom: 10px">快捷回复</span>
              <el-input v-model="quickReply" @input="filterReply" style="margin-bottom: 5px"></el-input>
              <div style="width: 98%; height: 150px; overflow: auto; border: 1px solid #e4e7ed; padding: 5px">
                <ol>
                  <li v-for="(item, index) of lotreplyOptions" :key="index" @click="getReply(item)" style="margin: 5px 0; cursor: default">{{ item.sort_number }} 、{{ item.val }}</li>
                </ol>
              </div>
            </div>
          </div>
          <el-button type="primary" @click="removetReply" style="margin: 20px">取消</el-button>
          <el-button type="primary" @click="sureReply" style="margin: 20px">确认</el-button>
        </el-dialog>

        <el-dialog title="通知" center :visible.sync="confirmAnswwer" width="30%" height="300px">
          <div style="text-align: center">是否进行短信提示</div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="sureMessage">是</el-button>
            <el-button type="primary" @click="removeMessage">否</el-button>
          </span>
        </el-dialog>

        <el-drawer ref="drawer" :custom-class="'drawer-self'" :title="popupTitle" :visible.sync="dialogFormVisible" :size="`${drawerH}px`" :direction="'ttb'" :before-close="closeDrawer">
          <el-form :model="formData" class="form">
            <div class="drawerLeft">
              <div class="drawerLeftTop">
                <div class="formItem">
                  <el-form-item label="工单号" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-input v-model="formData.work_sn" :disabled="idDisabled"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="游戏账号" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-input v-model="formData.account"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="游戏名称" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-input v-model="formData.game_name"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="游戏服" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-input v-model="formData.server"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="游戏角色名称" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-input v-model="formData.game_role_name"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="角色ID" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-input v-model="formData.game_role_id"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="联系方式" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-input v-model="formData.tel_num"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="问题类型" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-select v-model="formData.type_id" filterable placeholder="问题类型">
                        <el-option v-for="item in typeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="处理人" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-select v-model="formData.deal_user_id" filterable placeholder="处理人" :disabled="idDisabled">
                        <el-option v-for="item in dealData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="来源" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <p v-if="formData.from == 1">人工</p>
                      <p v-if="formData.from == 2">自助</p>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="工单状态" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-select v-model="formData.status" filterable placeholder="状态" :disabled="idDisabled">
                        <el-option v-for="item in statusData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                      </el-select>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="举报对象角色名" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-input v-model="formData.report_name" :disabled="formData.report_name == null ? true : false"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="投诉/表扬客服昵称" :label-width="formCheckWidth">
                    <el-col :span="20">
                      <el-input v-model="formData.customer_name" :disabled="formData.customer_name == null ? true : false"></el-input>
                    </el-col>
                  </el-form-item>
                </div>

                <!-- <el-row :gutter="20">
                <el-form-item label="真实姓名" :label-width="formCheckWidth">
                  <el-col :span="20">
                    <el-input v-model="formData.real_name" :disabled="formData.real_name == null ? true : false"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="绑定邮箱" :label-width="formCheckWidth">
                  <el-col :span="20">
                    <el-input v-model="formData.bind_email" :disabled="formData.bind_email == null ? true : false"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="身份证号" :label-width="formCheckWidth">
                  <el-col :span="20">
                    <el-input v-model="formData.id_number" :disabled="formData.id_number == null ? true : false"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="账号注册地点" :label-width="formCheckWidth">
                  <el-col :span="20">
                    <el-input v-model="formData.registion_addr" :disabled="formData.registion_addr == null ? true : false"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="常登陆地点" :label-width="formCheckWidth">
                  <el-col :span="20">
                    <el-input v-model="formData.commonly_addr" :disabled="formData.commonly_addr == null ? true : false"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="丢失时间" :label-width="formCheckWidth">
                  <el-col :span="20">
                    <el-input v-model="formData.lost_time" :disabled="formData.lost_time == null ? true : false"></el-input>
                  </el-col>
                </el-form-item>
                <el-form-item label="丢失物品" :label-width="formCheckWidth">
                  <el-col :span="20">
                    <el-input v-model="formData.lost_items" :disabled="formData.lost_items == null ? true : false"></el-input>
                  </el-col>
                </el-form-item>
              </el-row> -->

                <div class="textBox">
                  <el-form-item label="详情" :label-width="'40px'">
                    <el-col :span="24">
                      <el-input type="textarea" v-model="formData.details" :rows="6"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item label="备注" :label-width="'40px'">
                    <el-col :span="24">
                      <el-input type="textarea" v-model="formData.remarks" :rows="6" @blur="updataRemark"></el-input>
                    </el-col>
                  </el-form-item>
                  <el-form-item class="picBox" label="图片" :label-width="'40px'">
                    <el-upload
                      v-model="formData.enclosure"
                      :action="apiUrl"
                      drag
                      multiple
                      list-type="picture-card"
                      :file-list="getStableImageFileList('work-order-images', files)"
                      :headers="file_headers"
                      :on-preview="handlePreview"
                      :on-success="handleSuccess"
                      :on-remove="handleRemove"
                      :on-change="(file, fileList) => trackImageUpload('work-order-images', file, fileList)"
                      :on-error="(error, file, fileList) => handleUploadError('work-order-images', file, fileList)"
                    >
                      <i class="el-icon-plus"></i>
                    </el-upload>
                    <el-dialog :visible.sync="dialogImageVisible">
                      <img style="z-index: 2099" width="100%" :src="dialogImageUrl" alt />
                    </el-dialog>
                    <span v-if="!pic_status" style="color: red">工单图片异常，建议联系玩家确认</span>
                  </el-form-item>
                </div>
              </div>

              <el-table class="leftTable" :border="true" :data="tableLogData" v-if="formData.id != ''">
                <el-table-column prop="work_date" label="时间" />
                <el-table-column prop="work_sn" label="工单号" />
                <el-table-column prop="operation" label="操作" />
                <el-table-column prop="content" :show-overflow-tooltip="true" label="内容" />
                <el-table-column prop="files" width="150px" label="图片">
                  <template slot-scope="scope">
                    <el-image v-for="item in scope.row.files" :key="item.index" :src="item" style="width: 50px; height: 50px; margin-right: 5px" :preview-src-list="scope.row.files"> </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="deal_user" label="操作人" />
                <el-table-column prop="deal_user" label="">
                  <template slot-scope="scope">
                    <el-button size="mini" type="success" @click.native="correct(scope.row)" v-if="qualityShow == true && scope.row.recheck_button == 1">修正</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="drawerRight">
              <div class="addBox">
                <el-form-item v-if="workSnOperation" label="工单操作" :label-width="'70px'">
                  <el-col :span="24">
                    <el-button @click="handleShowLog(formData, 2)">添加进度</el-button>
                    <el-button @click="handleShowLog(formData, 4)" type="info" v-if="formData.from == 1">问题确认</el-button>
                    <el-button @click="handleShowLog(formData, 5)" type="success" v-if="formData.from == 1">玩家确认</el-button>
                    <el-button @click="handleShowLog(formData, 6)" type="warning" v-if="formData.from == 1">结束工单</el-button>
                    <el-button @click="handleShowLog(formData, 3)" type="info" v-if="formData.from == 2">分析回退</el-button>
                    <el-button @click="handleShowLog(formData, 7)" type="success" v-if="formData.from == 2">回复玩家</el-button>
                    <el-button v-if="qualityShow" @click="qualityReply" type="danger" plain>质检回复</el-button>
                    <el-button v-if="qualityShow" @click="replyCorrect" type="success" plain>回复正确</el-button>
                  </el-col>
                </el-form-item>
                <div class="progressBox" v-if="dialogLogFormVisible">
                  <el-form :model="formLogData" style="flex: 1.3">
                    <el-form-item label="是否跟进" :label-width="'70px'" v-if="goFurtherShow">
                      <el-col :span="20">
                        <el-radio v-model="status_processing_show" label="1">是</el-radio>
                        <el-radio v-model="status_processing_show" label="0">否</el-radio>
                      </el-col>
                    </el-form-item>
                    <div class="progressBoxHolder" v-if="!goFurtherShow"></div>
                    <el-form-item label="内容" :label-width="'70px'">
                      <el-col :span="22">
                        <el-input type="textarea" v-model="formLogData.content" :rows="5"></el-input>
                      </el-col>
                    </el-form-item>
                    <el-form-item class="contentPicBox" label="图片" :label-width="'70px'">
                      <el-upload
                        v-model="formLogData.files"
                        :action="apiUrl"
                        :headers="file_headers"
                        drag
                        multiple
                        list-type="picture-card"
                        :file-list="getStableImageFileList('progress-images', logFiles)"
                        :on-preview="handleLogPictureCardPreview"
                        :on-success="handleLogSuccess"
                        :on-remove="handleLogRemove"
                        :on-change="(file, fileList) => trackImageUpload('progress-images', file, fileList)"
                        :on-error="(error, file, fileList) => handleUploadError('progress-images', file, fileList)"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <el-dialog :visible.sync="dialogImageLogVisible">
                        <img width="100%" :src="dialogImageLogUrl" alt />
                      </el-dialog>
                    </el-form-item>
                  </el-form>

                  <div class="replyBox">
                    <p>快捷回复</p>
                    <el-input v-model="quickReply" @input="filterReply"></el-input>
                    <div class="listBox">
                      <ol>
                        <li v-for="(item, index) of lotreplyOptions" :key="index" @click="orderContent(item)" style="margin: 5px 0; cursor: default">{{ item.sort_number }} 、{{ item.val }}</li>
                      </ol>
                    </div>
                    <div class="replyBoxFooter">
                      <el-button @click="handleResetLogForm">取 消</el-button>
                      <el-button type="primary" @click="dialogVisible = true" v-if="formLogData.status == 3">确 定</el-button>
                      <el-button type="primary" @click="dialogVisible = true" v-else-if="formLogData.status == 7">确 定</el-button>
                      <el-button type="primary" @click="handleAddLog" v-else>确 定</el-button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="rightTable">
                <p>历史工单</p>
                <el-table :border="true" :data="hisTableData">
                  <el-table-column prop="created_at" label="提交日期" />
                  <el-table-column prop="work_sn" label="工单号">
                    <template slot-scope="scope">
                      <el-link @click="handleUpdate(scope.row, 1)" :type="hisColor(scope.row.work_sn)">{{ scope.row.work_sn }}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column prop="type" label="类型" />
                  <el-table-column :show-overflow-tooltip="true" prop="remarks" label="备注" />
                </el-table>
                <pagination v-show="hisTotal > 0" :total="hisTotal" :page.sync="hisListQuery.page" :limit.sync="hisListQuery.limit" @pagination="getHistoryList" />
              </div>
            </div>
          </el-form>
          <div class="drawerFooter">
            <div class="drawerFooterBtn">
              <el-button @click="cancelDrawer">取消</el-button>
              <el-button type="primary" @click="handleCreateUpdateStore" v-if="formData.id == ''">确 定</el-button>
              <el-button type="primary" @click="handleCreateUpdateStore" v-if="formData.from == 1">确 定</el-button>
            </div>
          </div>
        </el-drawer>

        <el-dialog title="二次质检" center width="50%" :visible.sync="correctShow">
          <el-input type="textarea" v-model="correctContent" :rows="8"></el-input>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeCorrect">取 消</el-button>
            <el-button type="primary" @click="sureCorrect">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="质检回复" center width="50%" :visible.sync="qualityReplyShow">
          <el-input type="textarea" v-model="qualityReplyContent" :rows="8"></el-input>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeQualityReply">取 消</el-button>
            <el-button type="primary" @click="sureQualityReply">确 定</el-button>
          </div>
        </el-dialog>

        <el-dialog title="提示" center :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
          <span>确认话术？</span>
          <br />
          <br />
          <span>
            短信提示？
            <el-radio v-model="formLogData.is_msn" label="1">是</el-radio>
            <el-radio v-model="formLogData.is_msn" label="0">否</el-radio>
          </span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="handleAddLog">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="添加备注" center :visible.sync="remarksShow" width="30%">
          <el-input type="textarea" v-model="remarksData"></el-input>
          <div slot="footer" class="dialog-footer">
            <el-button @click="removeRemarks">取消</el-button>
            <el-button type="primary" @click="sureRemarks">确认</el-button>
          </div>
        </el-dialog>

        <!-- 2021.03.04新增 自动回复弹窗 -->
        <el-dialog title="自动回复" center :visible.sync="autoReplyShow" width="50%">
          <div class="autoReply" v-for="(item, index) in autoReplyForm" :key="index">
            <span>工单类型：</span>
            <el-select v-model="item.type_id" :placeholder="'请选择'" filterable :style="{ width: '150px' }">
              <el-option v-for="item in typeData" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
            <span style="margin-left: 20px">状态：</span>
            <el-select v-model="item.reply_status" :placeholder="'请选择'" filterable :style="{ width: '150px' }">
              <el-option key="1" label="开启" :value="1"></el-option>
              <el-option key="0" label="关闭" :value="0"></el-option>
            </el-select>
            <span style="margin-left: 20px">回复内容：</span>
            <el-input type="textarea" v-model="item.content" :placeholder="'请输入'" :style="{ width: '250px', marginRight: '20px' }"></el-input>
            <el-button type="danger" plain @click="autoReplyDel(index)">删除</el-button>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="autoReplyAdd">添 加</el-button>
            <el-button type="primary" @click="autoReplySave">保 存</el-button>
          </div>
        </el-dialog>

        <!-- 2021.03.05新增 导入合服建议弹窗 -->
        <Dialog
          ref="dialog"
          @submitForm="dialogSure"
          @closeDialog="userSuggestClose"
          :dialogTitle="'导入合服建议'"
          :dialogVisible="userSuggestShow"
          :dialogModel="userSuggestModel"
          dialogWidth="700px"
        ></Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import {
  handleListApi,
  handleCreateStoreApi,
  handleDeleteApi,
  handleGetSelectApi,
  handleAddDealApi,
  handleDelDealApi,
  handleAddLogApi,
  handleWithdrawApi,
  handleLogDataApi,
  addAdminRemark,
  lotReply,
  fastReplyList,
  judgeModify,
  ensureWorksnOperation,
  handleGetQualitySelectApi,
  addQualityApi,
  FAQGetSelectApi,
  getImportFAQdataApi,
  importFAQdataApi,
  deleteApi,
  handoverOrderApi,
  batchExportExcelWorksn,
  setAutoReply,
  getAutoReply,
  getExportSuggestionSelect,
  batchExportToSuggestion,
  getWorkSnDetail,
  getHistoryList,
} from '@/api/work_sn.js';
import Pagination from '@/components/pagination/index';
import singlePublisher from '@/components/common/singlePublisher';
import BASE_API from '@/config';
import '@/assets/css/global.css';
import { getToken, setToken } from '@/utils/localStorage.js';
import table2excel from '@/vendor/table2Excel.js';
import { workSnColumn } from './config';
import Dialog from '../../common/Dialog';
import { appendImageInSelectionOrder, imageUploadMixin, normalizeImageList, removeImageByUploadFile } from '@/utils/imageUpload.js';

const PIC_STATUS = {
  SHOW: false, // 显示
};

export default {
  mixins: [imageUploadMixin],
  components: { Pagination, singlePublisher, Dialog },
  data() {
    return {
      // 列表
      typeData: [],
      statusData: [],
      degreeData: [
        { id: 1, name: '满意' },
        { id: 2, name: '一般' },
        { id: 3, name: '不满意' },
      ],
      dealData: [],
      listLoading: false,
      popupTitle: '',
      total: 0,
      tableData: [],
      listQuery: {
        id: '',
        page: 1,
        limit: 10,
        game_name: '',
        from: 2,
        quality_admin_id: '',
        quality_status: null,
        markAccount: '',
      },

      // 添加数据的缓存。
      addData: {},
      addCheck: 0,

      //记录列表
      tableLogData: [],
      // 表单
      dialogFormVisible: false,
      idDisabled: true,
      formData: {
        id: '',
        work_sn: '',
        user_id: '',
        game_role_id: '',
        account: '',
        game_name: '',
        server: '',
        game_role_name: '',
        tel_num: '',
        status: '',
        type_id: '',
        deal_user_id: '',
        details: '',
        remarks: '',
        from: '',
        enclosure: [],
        real_name: '',
        bind_email: '',
        id_number: '',
        registion_addr: '',
        commonly_addr: '',
        lost_time: '',
        lost_items: '',
        report_name: '',
        customer_name: '',
      },
      formLabelWidth: '120px',
      formCheckWidth: '130px',
      formInputWidth: '200px',
      delShow: false,
      delID: '',
      delete_button: false,
      withdraw_button: false,
      faq_button: false,

      //记录表单
      dialogLogFormVisible: false,
      idLogDisabled: true,
      formLogData: {
        id: '',
        work_sn: '',
        status: '',
        content: '',
        handleAddLog: [],
        is_msn: '',
        fast_reply_id: '',
      },
      //图片上传
      // apiUrl:'http://worksn.hzwxbz2.cn/api/v1/admin/work_upload',
      apiUrl: BASE_API + 'admin/work_upload_admin',
      dialogImageUrl: '',
      files: [],
      dialogImageVisible: false,
      //提示弹框
      dialogVisible: false,
      //记录图片上传
      dialogImageLogUrl: '',
      logFiles: [],
      dialogImageLogVisible: false,
      file_headers: {
        //头带当前用户信息
        Authorization: 'Bearer ' + getToken(),
      },
      remarksShow: false,
      remarksData: '',
      remarksId: undefined,
      //批量回复
      batchReply: false,
      replyArea: '',
      replyOptions: [],
      lotreplyOptions: [],
      confirmAnswwer: false,
      quickReply: '',
      multipleSelection: [],
      checkFastReply: '',

      //质检
      qualityTestingOptions: [],
      qualityPersonOptions: [],
      qualityReplyContent: '',
      qualityReplyShow: false,
      qualityShow: true,

      // 二次质检
      correctShow: false,
      correctContent: '',
      twiceCheckID: '',

      // 查看
      look: false,
      workOrder: {},
      operateCheck: '',
      // 撤回
      withdraw: false,

      // faq
      faq: {
        work_sn_id: '',
        gameName: '',
        questionType: '',
        questionDetail: '',
        answerDetail: '',
        questionImages: '',
        answerImages: '',
      },
      importFAQShow: false,
      faqGameNameOptions: [],
      faqQuestionTypeOptions: [],
      questionDetailFiles: [],
      answerOptions: [],
      answerDetail: {},
      faqAnswerUploadSeed: 0,

      // 账号标记
      special_flagOptions: [],

      // 跟进
      status_processing_show: '',
      goFurtherShow: false,

      // 图片状态判断
      pic_status: true,

      // 工单交接
      questionShow: false,
      noticeReceiver: [],
      question: {},
      current_number: {},
      autoReplyShow: false,
      autoReplyForm: [],
      userSuggestShow: false,
      userSuggestType: false,
      userSuggestId: [],
      userSuggestTypeOption: [],
      userSuggestGameOption: [],
      hisListQuery: {
        user_id: '',
        page: 1,
        limit: 10,
      },
      hisTotal: 0,
      hisTableData: [],
      workSnOperation: false,
      drawerH: '',
      currentId: 0,
      currentWordSn: 0,
    };
  },
  computed: {
    addControl() {
      let item = true;
      if (this.popupTitle == '添加') {
        item = false;
      }
      return item;
    },
    userSuggestModel() {
      if (!!this.userSuggestType) {
        return [
          {
            type: 'el-select',
            label: '玩家建议类型',
            prop: 'suggestion_type',
            placeholder: '请选择玩家建议类型',
            options: this.userSuggestTypeOption,
          },
          {
            type: 'el-select',
            label: '游戏ID',
            prop: 'game_id',
            placeholder: '请选择游戏ID',
            options: this.userSuggestGameOption,
          },
          {
            type: 'el-input-textarea',
            label: '玩家建议内容',
            prop: 'content',
            placeholder: '请选择玩家建议内容',
          },
        ];
      }
      return [
        {
          type: 'el-select',
          label: '玩家建议类型',
          prop: 'suggestion_type',
          placeholder: '请选择玩家建议类型',
          options: this.userSuggestTypeOption,
        },
        {
          type: 'el-select',
          label: '游戏ID',
          prop: 'game_id',
          placeholder: '请选择游戏ID',
          options: this.userSuggestGameOption,
        },
      ];
    },
  },
  async created() {
    this.handleList(this.listQuery);
    this.handleGetSelect();
    this.getQualityTestingSelect();
    this.getQualityPersonSelect();
    this.FAQGetSelect();
    this.getExportSuggestionSelect();
    const r = await fastReplyList();
    let list = r.data.data;
    list.sort(this.compare('sort_number'));
    for (let item of list) {
      let m = {
        val: '',
        sort_number: '',
        id: '',
      };
      m.val = String(item.content);
      m.id = item.id;
      m.sort_number = item.sort_number;
      this.replyOptions.push(m);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.multipleTable.doLayout();
    });
    this.drawerH = document.documentElement.clientHeight;
  },
  methods: {
    async updataRemark() {
      const obj = {
        id: this.formData.id,
        admin_remarks: this.formData.remarks,
      };
      const { data } = await addAdminRemark(obj);
      console.log(data);
      if (data.code !== 1) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('修改备注成功！');
      this.handleList();
    },
    hisColor(workSn) {
      if (this.currentWordSn === workSn) {
        return 'danger';
      } else if (this.formData.work_sn === workSn) {
        return 'success';
      } else {
        return 'primary';
      }
    },
    // 2021.03.05新增 导入合服建议
    handleUserSuggest(type) {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择工单后，再进行导入');
        return;
      }
      this.multipleSelection.forEach((item) => {
        this.userSuggestId.push(item.id);
      });
      this.userSuggestType = false;
      this.userSuggestShow = true;
    },
    // 导入合服建议提交
    async dialogSure(form) {
      const { data } = await batchExportToSuggestion(Object.assign({ id_array: this.userSuggestId }, form));
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('修改成功');
      this.userSuggestClose();
      this.handleList();
    },
    // 关闭导入合服建议弹窗
    userSuggestClose() {
      this.userSuggestId = [];
      this.userSuggestShow = false;
      this.$refs.dialog.resetForm();
    },
    singleSuggest(row) {
      this.userSuggestId = [row.id];
      this.userSuggestType = true;
      this.userSuggestShow = true;
    },
    // 获取下拉框选项
    async getExportSuggestionSelect() {
      const { data } = await getExportSuggestionSelect();
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      const { game, type } = data.data;
      this.userSuggestTypeOption = type.map((m) => {
        return { label: m.name, value: m.id };
      });
      this.userSuggestGameOption = game.map((m) => {
        return { label: m.name, value: m.id };
      });
    },
    // 2021.03.04新增 点击导出
    async handleExport() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择工单后，再进行导出');
        return;
      }
      const data = { id_array: [] };
      for (let item of this.multipleSelection) {
        data.id_array.push(item.id);
      }
      const r = await batchExportExcelWorksn(data);
      if (r.data.code !== 200) {
        this.$message.error(r.data.message);
        return;
      }
      // console.log(r.data.data);
      table2excel(workSnColumn, r.data.data, '工单');
    },
    // 2021.03.04新增 设置自动回复
    async handleAutoReply() {
      const { data } = await getAutoReply();
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.autoReplyShow = true;
      this.autoReplyForm = data.data;
    },
    // 自动回复新增
    autoReplyAdd() {
      this.autoReplyForm.push({ type_id: '', reply_status: '', content: '' });
    },
    // 自动回复删除
    autoReplyDel(index) {
      this.autoReplyForm.splice(index, 1);
    },
    // 自动回复保存
    async autoReplySave() {
      const { data } = await setAutoReply({ data: this.autoReplyForm });
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.autoReplyShow = false;
      this.$message.success('设置成功！');
      this.autoReplyForm = [];
    },
    del(item) {
      this.delID = item.id;
      this.delShow = true;
    },
    sureDel() {
      deleteApi({ id: this.delID })
        .then((response) => {
          if (response.data.code == 200) {
            this.$message.success(response.data.message);
            this.handleList();
            this.delShow = false;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {});
    },
    handleList() {
      this.listLoading = true;
      handleListApi(this.listQuery)
        .then((response) => {
          const data = response.data.data;
          this.tableData = data;
          this.total = response.data.total;
          this.delete_button = response.data.delete_button;
          this.withdraw_button = response.data.withdraw_button;
          this.faq_button = response.data.faq_button;
          this.current_number = response.data.current_number;
          setTimeout(() => {
            this.listLoading = false;
          }, 0.5 * 1000);
          this.$nextTick(() => {
            this.$refs.multipleTable.doLayout();
          });
        })
        .catch((error) => {
          this.listLoading = false;
        });
    },
    // 发票，投诉账号的划分
    levelColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 3) {
        if (row.special_flag == 1) {
          return 'color:#f59a23;font-width:bold;font-size:14px;';
        } else if (row.special_flag == 2) {
          return 'color:red;font-width:bold;font-size:14px;';
        } else if ((1 & row.special_flag) == 1 && (2 & row.special_flag) == 2) {
          return 'color:#6a2c34;font-width:bold;font-size:14px;';
        } else {
          return 'color:black;font-width:bold;';
        }
      }
    },
    getQualityTestingSelect() {
      let data = {
        name: 'quality_status',
      };
      handleGetQualitySelectApi(data)
        .then((response) => {
          let data = response.data;
          for (let item of data) {
            let m = {
              name: '',
              id: '',
            };
            m.name = item.name;
            m.id = item.id;
            this.qualityTestingOptions.push(m);
          }
        })
        .catch((error) => {});
    },
    getQualityPersonSelect() {
      let data = {
        name: 'quality_admin',
      };
      handleGetQualitySelectApi(data)
        .then((response) => {
          let data = response.data;
          for (let item of data) {
            let m = {
              name: '',
              id: '',
            };
            m.name = item.name;
            m.id = item.id;
            this.qualityPersonOptions.push(m);
          }
        })
        .catch((error) => {});
    },
    handleGetSelect() {
      handleGetSelectApi()
        .then((response) => {
          this.typeData = response.data.type;
          this.dealData = response.data.user;
          this.statusData = response.data.status;
          this.special_flagOptions = response.data.special_flag;
        })
        .catch((error) => {});
    },
    handleResetLogForm() {
      this.resetImageUploadScope('progress-images');
      this.formLogData.files = [];
      this.formLogData.is_msn = '';
      this.logFiles = [];
      this.dialogLogFormVisible = false;
      this.quickReply = '';
    },
    handleResetSearch() {
      if (this.listQuery.work_sn != undefined) {
        this.listQuery.work_sn = undefined;
      }
      if (this.listQuery.account != undefined) {
        this.listQuery.account = undefined;
      }
      if (this.listQuery.server != undefined) {
        this.listQuery.server = undefined;
      }
      if (this.listQuery.game_role_name != undefined) {
        this.listQuery.game_role_name = undefined;
      }
      if (this.listQuery.tel_num != undefined) {
        this.listQuery.tel_num = undefined;
      }
      if (this.listQuery.type_id != undefined) {
        this.listQuery.type_id = undefined;
      }
      if (this.listQuery.deal_user_id != undefined) {
        this.listQuery.deal_user_id = undefined;
      }
      if (this.listQuery.status != undefined) {
        this.listQuery.status = [];
      }
      if (this.listQuery.degree != undefined) {
        this.listQuery.degree = [];
      }
      if (this.listQuery.created_at != undefined) {
        this.listQuery.created_at = undefined;
      }
      if (this.listQuery.vip != undefined) {
        this.listQuery.vip = undefined;
      }
      if (this.listQuery.created_user != undefined) {
        this.listQuery.created_user = undefined;
      }
      if (this.listQuery.quality_status != undefined) {
        this.listQuery.quality_status = undefined;
      }
      if (this.listQuery.quality_admin_id != undefined) {
        this.listQuery.created_user = undefined;
      }
      if (this.listQuery.game_name != undefined) {
        this.listQuery.game_name = undefined;
      }
      this.listQuery.page = 1;
      this.listQuery.limit = 10;
      if (this.listQuery.special_flag != undefined) {
        this.listQuery.special_flag = undefined;
      }
      this.handleList(this.listQuery);
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.handleList(this.listQuery);
    },
    handleMyFilter() {
      this.listQuery.deal_user_id = this.tableData[0].admin_id;
      this.handleList(this.listQuery);
    },
    closeDrawer(done) {
      this.resetImageUploadScope('work-order-images');
      this.resetImageUploadScope('progress-images');
      this.formData = {};
      this.closeDialog();
      this.handleResetLogForm();
      done();
    },
    cancelDrawer() {
      this.$refs.drawer.closeDrawer();
    },
    closeDialog() {
      if (this.popupTitle == '添加' && (this.addCheck == 0 || this.addCheck == 1)) {
        this.addData = JSON.parse(JSON.stringify(this.formData));
        this.addCheck = 1;
      }
      if (this.popupTitle == '添加' && this.addCheck == 2) {
        this.addCheck = 0;
        this.addData = {};
      }
    },
    handleCreateUpdateStore() {
      if (!this.guardImageUploads(['work-order-images'])) return;
      if (this.formData.account == '') {
        this.$message.error('请添加游戏账号！');
        return false;
      }
      if (this.formData.game_name == '') {
        this.$message.error('请添加游戏名！');
        return false;
      }
      if (this.formData.game_role_name == '') {
        this.$message.error('请添加游戏角色名称！');
        return false;
      }
      if (this.formData.server == '') {
        this.$message.error('请添加游戏服！');
        return false;
      }
      handleCreateStoreApi(this.formData)
        .then((response) => {
          const data = response.data;
          this.$message.success('操作成功');
          if (this.operateCheck == 1) {
            this.addCheck = 2;
          }
          this.dialogFormVisible = false;
          this.handleList(this.listQuery);
        })
        .catch((error) => {});
    },
    //  质检
    qualityReply() {
      this.qualityReplyContent = '';
      this.qualityReplyShow = true;
    },
    replyCorrect() {
      let data = {
        id: '',
        status: 1,
      };
      data.id = this.formData.id;
      addQualityApi(data)
        .then((response) => {
          if (response.data.code === 200) {
            this.$message.success(response.data.message);
            this.updataLogData();
            this.handleList(this.listQuery);
            this.quickReply = '';
            this.handleResetLogForm();
            this.handleUpdate(this.formData);
          } else if (response.data.code !== 200) {
            this.$message.error(response.data.message);
            this.quickReply = '';
          }
        })
        .catch((error) => {});
    },
    removeQualityReply() {
      this.qualityReplyContent = '';
      this.qualityReplyShow = false;
    },
    sureQualityReply() {
      let data = {
        id: '',
        status: 2,
        content: '',
      };
      data.id = this.formData.id;
      data.content = this.qualityReplyContent;
      this.qualityReplyShow = false;
      addQualityApi(data)
        .then((response) => {
          if (response.data.code === 200) {
            this.$message.success(response.data.message);
            this.updataLogData();
            this.handleList(this.listQuery);
            this.quickReply = '';
            this.handleResetLogForm();
            this.handleUpdate(this.formData);
          } else if (response.data.code !== 200) {
            this.$message.error(response.data.message);
            this.quickReply = '';
          }
        })
        .catch((error) => {});
    },

    // 二次质检
    correct(item) {
      this.twiceCheckID = item.check_id;
      this.correctShow = true;
      this.correctContent = '';
    },
    removeCorrect() {
      this.correctShow = false;
    },
    sureCorrect() {
      let data = {
        id: '',
        status: 3,
        content: '',
        check_id: '',
      };
      data.id = this.formData.id;
      data.content = this.correctContent;
      data.check_id = this.twiceCheckID;
      this.correctShow = false;
      addQualityApi(data)
        .then((response) => {
          if (response.data.code === 200) {
            this.$message.success(response.data.message);
            this.updataLogData();
            this.handleList(this.listQuery);
            this.quickReply = '';
            this.handleResetLogForm();
            this.handleUpdate(this.formData);
          } else if (response.data.code !== 200) {
            this.$message.error(response.data.message);
            this.quickReply = '';
          }
        })
        .catch((error) => {});
    },
    async handleUpdate(row, type = 0) {
      const { data } = await getWorkSnDetail(row.id);
      if (data.code !== 200) return;
      if (type === 2) {
        this.currentId = row.id;
        this.currentWordSn = data.data.work_sn || 0;
      }
      if (this.formData.id && row.id !== this.currentId) {
        console.log('zhong');
        this.workSnOperation = false;
      } else {
        this.workSnOperation = true;
      }
      if (type === 1) {
        this.handleResetLogForm();
      }
      this.popupTitle = '查看';
      this.operateCheck = 0;
      this.workOrder = data.data;
      this.pic_status = this.workOrder.pic_status !== PIC_STATUS.SHOW;
      if (this.workOrder.from_name == '自助' && type === 2) {
        judgeModify({ work_sn: this.workOrder.work_sn })
          .then((response) => {
            if (response.data.data.confirm_window == 1) {
              this.look = true;
            } else if (response.data.data.confirm_window == 0) {
              this.sureTime();
              this.singleWorkOrderContent();
            }
          })
          .catch((error) => {
            this.look = false;
          });
      } else if (row.from_name == '人工' || type === 1) {
        this.singleWorkOrderContent();
      }
    },
    handleAddDeal(row) {
      handleAddDealApi(row)
        .then((response) => {
          if (response.data.code == 1) {
            this.$message.success('操作成功');
          } else {
            this.$message.error(response.data.message);
          }
          this.handleList(this.listQuery);
        })
        .catch((error) => {});
    },
    handleDelDeal(row) {
      handleDelDealApi(row)
        .then((response) => {
          this.$message.success('操作成功');
          this.handleList(this.listQuery);
        })
        .catch((error) => {});
    },
    handleDelete(row) {
      handleDeleteApi(row)
        .then((response) => {
          this.$message.success('操作成功');
          row.deleteVisible = false;
          this.handleList(this.listQuery);
        })
        .catch((error) => {});
    },
    // 工单交接
    handoverQuestion(item) {
      this.question = [];
      this.noticeReceiver = [];
      item.images = [];
      if (item.enclosure.length > 0) {
        item.images = item.enclosure.map((item2) => {
          return item2.url;
        });
      }
      this.question = item;
      this.questionShow = true;
    },
    sureHandover() {
      if (this.noticeReceiver.length == 0) {
        this.$message.error('请先选择接管人');
        return;
      }
      let data = {};
      data.id = this.question.id;
      data.admin_id = this.noticeReceiver[this.noticeReceiver.length - 1];
      handoverOrderApi(data).then((response) => {
        if (response.data.code == 200) {
          this.$message.success('操作成功');
          this.questionShow = false;
          this.handleList(this.listQuery);
        }
      });
    },
    handleShowLog(info, status) {
      this.resetImageUploadScope('progress-images');
      this.lotreplyOptions = this.replyOptions;
      if (info.from == 1) {
        judgeModify({ work_sn: this.formData.work_sn })
          .then((response) => {
            this.lotreplyOptions = this.replyOptions;
            this.formLogData.id = info.id;
            this.formLogData.status = status;
            if (response.data.data.confirm_window == 1) {
              this.look = true;
            } else if (response.data.data.confirm_window == 0) {
              this.dialogLogFormVisible = true;
            }
          })
          .catch((error) => {
            this.look = false;
          });
      } else if (info.from == 2) {
        if (status == 7) {
          this.goFurtherShow = true;
          this.status_processing_show = '0';
        } else {
          this.goFurtherShow = false;
        }
        this.lotreplyOptions = this.replyOptions;
        this.dialogLogFormVisible = true;
        this.formLogData.id = info.id;
        this.formLogData.status = status;
        this.quickReply = '';
      }
    },
    handleAddLog() {
      if (!this.guardImageUploads(['progress-images'])) return;
      if (this.formLogData.status == 7 && this.status_processing_show == 1) {
        this.formLogData.status_processing_show = 1;
        this.formLogData.status = 2;
      } else if (this.formLogData.status == 2) {
        this.formLogData.status_processing_show = 0;
      }
      if (this.formLogData.status != 2) {
        this.$delete(this.formLogData, 'status_processing_show');
      }
      this.dialogVisible = false;
      this.dialogFormVisible = false;
      handleAddLogApi(this.formLogData)
        .then((response) => {
          this.formLogData.is_msn = '';
          if (response.data.code === 200) {
            console.log('123213');
            this.$message.success('操作成功');
            this.dialogLogFormVisible = false;
            this.quickReply = '';
            this.handleResetLogForm();
            this.handleUpdate(this.formData);
            // todo 需要前端再验证
            this.handleList(this.listQuery);
          } else if (response.data.code !== 200) {
            this.$message.error(response.data.message);
            this.quickReply = '';
          }
        })
        .catch((error) => {
          this.$message.error(JSON.stringify(error));
        });
    },
    handleRemove(file, fileList) {
      this.files = removeImageByUploadFile(this.files, file);
      this.formData.enclosure = this.files;
      this.removeTrackedImage('work-order-images', file, fileList);
    },
    handlePreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogImageVisible = true;
    },
    handleSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('work-order-images', file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload('work-order-images', file, fileList);
        this.$message.error(response.message);
      } else {
        this.files = appendImageInSelectionOrder(this.files, file, { url: response.data.path, name: response.data.name || file.name });
        this.formData.enclosure = this.files;
        this.trackImageUpload('work-order-images', file, fileList);
        this.$message.success(response.message);
      }
    },
    handleLogPictureCardPreview(file) {
      this.dialogImageLogUrl = file.url;
      this.dialogImageLogVisible = true;
    },
    handleLogSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('progress-images', file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload('progress-images', file, fileList);
        this.$message.error(response.message);
      } else {
        this.logFiles = appendImageInSelectionOrder(this.logFiles, file, { url: response.data.path, name: response.data.name || file.name });
        this.formLogData.files = this.logFiles.map((item) => item.url);
        this.trackImageUpload('progress-images', file, fileList);
        this.$message.success(response.message);
      }
    },
    handleLogRemove(file, fileList) {
      this.logFiles = removeImageByUploadFile(this.logFiles, file);
      this.formLogData.files = this.logFiles.map((item) => item.url);
      this.removeTrackedImage('progress-images', file, fileList);
    },
    handleUploadError(scope, file, fileList) {
      if (!this.isCurrentImageUpload(scope, file)) return;
      this.trackImageUpload(scope, file, fileList);
      this.$message.error(`${file.name || '图片'}上传失败`);
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    // 撤回操作
    handleWithdraw(work_sn) {
      this.withdraw = true;
      this.recallData = work_sn;
    },
    async sureRecall() {
      handleWithdrawApi(this.recallData)
        .then((response) => {
          if (response.data.code === 200) {
            this.$message.success(response.data.message);
          } else if (response.data.code !== 200) {
            this.$message.error(response.data.message);
          }
          this.withdraw = false;
        })
        .catch((error) => {
          this.$message.error(error);
          this.withdraw = false;
        });
    },
    removeRecall() {
      this.withdraw = false;
      this.recallData = {};
    },
    // 批量回复
    async replyShow() {
      if (this.multipleSelection.length == 0) {
        this.$message.error('请选择工单后，再进行回复');
        return;
      } else {
        this.batchReply = true;
        this.replyArea = '';
        this.lotreplyOptions = this.replyOptions;
      }
    },
    removetReply() {
      this.batchReply = false;
    },
    sureReply() {
      if (this.replyArea == '') {
        this.$message.error('请输入批量回复内容');
        return;
      }
      this.confirmAnswwer = true;
      this.batchReply = false;
    },
    // 回复工单
    removeOperate() {
      this.look = false;
    },
    sureOperate() {
      if (this.workOrder.from == 1) {
        this.sureTime();
        this.look = false;
        this.dialogLogFormVisible = true;
      } else if (this.workOrder.from == 2) {
        this.sureTime();
        this.singleWorkOrderContent();
      }
    },
    // 短信
    removeMessage() {
      this.batchReply = false;
      this.confirmAnswwer = false;
      let data = {
        id_array: [],
        content: '',
        fast_reply_id: '',
        is_msn: '',
      };
      for (let item of this.multipleSelection) {
        data.id_array.push(item.id);
      }
      data.content = this.replyArea;
      data.fast_reply_id = this.checkFastReply;
      data.is_msn = 0;
      this.batchReplyApi(data);
    },

    async sureMessage() {
      this.batchReply = false;
      this.confirmAnswwer = false;
      let data = {
        id_array: [],
        content: '',
        fast_reply_id: '',
        is_msn: '',
      };
      for (let item of this.multipleSelection) {
        data.id_array.push(item.id);
      }
      data.fast_reply_id = this.checkFastReply;
      data.content = this.replyArea;
      data.is_msn = 1;
      this.batchReplyApi(data);
    },
    // 禁用人工 快捷回复
    checkboxT(row, rowIndex) {
      if (row.from == 1) {
        return false;
      } else {
        return true;
      }
    },
    // 选择回复内容
    select(item) {
      this.replyArea = this.quickReply;
      this.checkFastReply = item.id;
    },
    filterReply() {
      let data = [];
      if (parseInt(this.quickReply) != this.quickReply) {
        for (let item of this.replyOptions) {
          if (item.val.indexOf(this.quickReply) != -1) {
            data.push(item);
          }
        }
      } else if (parseInt(this.quickReply) == this.quickReply) {
        for (let item of this.replyOptions) {
          if (item.sort_number == this.quickReply) {
            data.push(item);
          }
        }
        if (data.length == 0) {
          for (let item of this.replyOptions) {
            if (item.val.indexOf(this.quickReply) != -1) {
              data.push(item);
            }
          }
        }
      }
      this.lotreplyOptions = data;
    },
    getReply(item) {
      this.replyArea = item.val;
      this.checkFastReply = item.id;
    },
    //批量回复
    batchReplyApi(data) {
      lotReply(data)
        .then((response) => {
          if (response.data.code === 200) {
            this.$message.success(response.data.message);
            this.handleList(this.listQuery);
            this.handleGetSelect();
          } else if (response.data.code !== 200) {
            this.$message.error(response.data.message);
          }
          this.dialogLogFormVisible = false;
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },
    //排序
    sortChange(column) {
      this.listQuery.sortName = column.prop;
      this.listQuery.sortType = column.order;
      this.handleList(this.listQuery);
    },
    // 工单内容
    orderContent(item) {
      this.formLogData.content = item.val;
      this.formLogData.fast_reply_id = item.id;
    },
    // 获取单个工单 统计的内容
    singleWorkOrderContent() {
      this.resetImageUploadScope('work-order-images');
      this.dialogFormVisible = true;
      this.look = false;
      this.formLogData.content = '';
      const row = this.workOrder;
      this.formData.id = row.id;
      this.formData.work_sn = row.work_sn;
      this.formData.user_id = row.user_id;
      this.formData.game_role_id = row.game_role_id;
      this.formData.account = row.account;
      this.formData.game_name = row.game_name;
      this.formData.server = row.server;
      this.formData.game_role_name = row.game_role_name;
      this.formData.tel_num = row.tel_num;
      this.formData.status = row.status;
      this.formData.type_id = row.type_id;
      this.formData.deal_user_id = row.deal_user_id;
      this.formData.details = row.details;
      this.formData.remarks = row.remarks;
      this.formData.from = row.from;
      this.formData.enclosure = normalizeImageList(row.enclosure, 'work-order');
      this.files = this.formData.enclosure;
      this.formData.real_name = row.real_name;
      this.formData.bind_email = row.bind_email;
      this.formData.id_number = row.id_number;
      this.formData.registion_addr = row.registion_addr;
      this.formData.commonly_addr = row.commonly_addr;
      this.formData.lost_time = row.lost_time;
      this.formData.lost_items = row.lost_items;
      this.formData.report_name = row.report_name;
      this.formData.customer_name = row.customer_name;
      this.formData.quality_testing_status_text = row.quality_testing_status_text;
      this.updataLogData();
      this.getHistoryList();
    },
    updataLogData() {
      let data = {
        work_sn: '',
      };
      data.work_sn = this.formData.work_sn;
      handleLogDataApi(data)
        .then((response) => {
          if (response.data.show_check_button == true) {
            this.qualityShow = true;
          } else if (response.data.show_check_button == false) {
            this.qualityShow = false;
          }
          const data = response.data.data;
          this.tableLogData = data;
        })
        .catch((error) => {});
    },
    async getHistoryList() {
      this.hisListQuery.user_id = this.formData.user_id;
      const { data } = await getHistoryList(this.hisListQuery);
      if (data.code !== 200) return;
      this.hisTotal = data.data.total;
      this.hisTableData = data.data.data;
    },
    // 开始计时
    sureTime() {
      let data = {};
      data.work_sn = this.workOrder.work_sn;
      ensureWorksnOperation(data)
        .then((response) => {})
        .catch((error) => {});
    },
    // 添加备注
    addRemarks(row) {
      this.remarksShow = true;
      this.remarksId = row.id;
      this.remarksData = row.remarks;
    },
    // 取消添加备注操作
    removeRemarks() {
      this.remarksData = '';
      this.remarksId = undefined;
      this.remarksShow = false;
    },
    // 确认添加备注操作
    async sureRemarks() {
      const data = {
        id: this.remarksId,
        admin_remarks: this.remarksData,
      };
      const r = await addAdminRemark(data);
      this.removeRemarks();
      this.handleList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    answerHandleSelectionChange(val) {
      this.answerDetail = val;
    },
    // 排序
    compare(property) {
      return function (a, b) {
        let m = a[property];
        let n = b[property];
        return m - n;
      };
    },

    // faq
    FAQGetSelect() {
      FAQGetSelectApi()
        .then((response) => {
          this.faqQuestionTypeOptions = response.data.type;
          this.faqGameNameOptions = response.data.game;
        })
        .catch((error) => {});
    },
    importFAQ(row) {
      this.resetFaqImageUploads();
      this.faq.work_sn_id = row.id;
      (this.faq.questionType = ''), (this.faq.gameName = '');
      let data = {
        id: '',
      };
      data.id = row.id;
      this.getImportFAQdata(data);
      this.questionDetailFiles = normalizeImageList(row.enclosure, 'faq-question');
      this.faq.questionImages = this.questionDetailFiles;
      this.importFAQShow = true;
      this.answerDetail = [];
    },
    sureImportFAQ() {
      if (!this.guardImageUploads(this.faqImageScopes())) return;
      if (this.faq.gameName == '') {
        this.$message.error('请选择游戏名称');
        return;
      }
      if (this.faq.questionType == '') {
        this.$message.error('请选择问题类型');
        return;
      }
      if (this.faq.questionDetail == '') {
        this.$message.error('问题详情不能为空');
        return;
      }
      if (this.answerDetail.length == 1) {
        let data = {
          work_sn_id: '',
          problem: '',
          answer: '',
          game_id: '',
          type_id: '',
          problem_images: [],
          answer_images: [],
        };
        data.work_sn_id = this.faq.work_sn_id;
        data.problem = this.faq.questionDetail;
        data.game_id = this.faq.gameName;
        data.type_id = this.faq.questionType;
        data.answer = this.answerDetail[0].content;

        for (let item of this.questionDetailFiles) {
          data.problem_images.push(item.url);
        }

        for (let item of this.answerDetail[0].images) {
          data.answer_images.push(item.url);
        }
        importFAQdataApi(data)
          .then((response) => {
            if (response.data.code == '200') {
              this.$message.success(response.data.message);
            } else if (response.data.code != '200') {
              this.$message.error(response.data.message);
            }
            this.importFAQShow = false;
          })
          .catch((error) => {});
      } else if (this.answerDetail.length != 1) {
        let info = '';
        if (this.answerDetail.length == 0) {
          this.$message.error('请选择一条答案详情');
        } else if (this.answerDetail.length > 1) {
          this.$message.error('请确保只选择一条答案');
        }
      }
    },
    removeImportFAQ() {
      this.resetFaqImageUploads();
      this.importFAQShow = false;
    },
    fileChange(response, file, fileList, item) {
      if (!this.isCurrentImageUpload(item.uploadScope, file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload(item.uploadScope, file, fileList);
        this.$message.error(response.message);
      } else {
        const path = response.data ? response.data.path : response.path;
        item.images = appendImageInSelectionOrder(item.images, file, { url: path, name: (response.data && response.data.name) || file.name });
        this.trackImageUpload(item.uploadScope, file, fileList);
        this.$message.success(response.message);
      }
    },
    answerRemove(file, fileList, item) {
      item.images = removeImageByUploadFile(item.images, file);
      this.removeTrackedImage(item.uploadScope, file, fileList);
    },
    // FAQ 问题详情图片

    questionPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogImageVisible = true;
    },
    questionSuccess(response, file, fileList) {
      if (!this.isCurrentImageUpload('faq-question', file)) return;
      if (response.code != 200) {
        file.status = 'fail';
        this.trackImageUpload('faq-question', file, fileList);
        this.$message.error(response.message);
      } else {
        this.questionDetailFiles = appendImageInSelectionOrder(this.questionDetailFiles, file, { url: response.data.path, name: response.data.name || file.name });
        this.faq.questionImages = this.questionDetailFiles;
        this.trackImageUpload('faq-question', file, fileList);
        this.$message.success(response.message);
      }
    },
    questionRemove(file, fileList) {
      this.questionDetailFiles = removeImageByUploadFile(this.questionDetailFiles, file);
      this.faq.questionImages = this.questionDetailFiles;
      this.removeTrackedImage('faq-question', file, fileList);
    },
    faqImageScopes() {
      return ['faq-question'].concat(this.answerOptions.map((item) => item.uploadScope).filter(Boolean));
    },
    resetFaqImageUploads() {
      this.faqImageScopes().forEach((scope) => this.resetImageUploadScope(scope));
    },
    getImportFAQdata(a) {
      getImportFAQdataApi(a)
        .then((response) => {
          this.answerOptions = [];
          this.faq.questionDetail = response.data.data.question;
          let image = [];
          for (let item of response.data.data.answer) {
            let data = {
              content: '',
              images: [],
              uploadScope: `faq-answer-${++this.faqAnswerUploadSeed}`,
            };
            data.content = item.content;
            for (let m of item.files) {
              let n = {
                url: '',
              };
              n.url = m;
              data.images.push(n);
            }
            data.images = normalizeImageList(data.images, data.uploadScope);
            this.answerOptions.push(data);
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
div.el-transfer .el-transfer-panel {
  width: 400px;
}
.autoReply {
  width: 100%;
  height: 80px;
  display: flex;
  align-items: center;
  /* background-color: pink; */
}
.drawer-self {
  overflow-y: auto;
  z-index: 1999;
}
.form {
  height: auto;
  display: flex;
  margin-left: 10px;
  /* background-color: pink; */
}
.drawerLeft {
  width: 60%;
  /* background-color: lightgreen; */
}
.drawerLeftTop {
  width: 100%;
  display: flex;
}
.drawerRight {
  width: 40%;
  /* background-color: lightblue; */
}
.formItem {
  width: 45%;
}
.textBox {
  width: 50%;
  margin-right: 20px;
}
.addBox {
  width: 640px;
  padding-left: 10px;
}
.progressBox {
  display: flex;
  justify-content: space-between;
}
.progressBoxHolder {
  height: 50px;
}
.replyBox {
  flex: 0.7;
}
.replyBox > p {
  font-size: 14px;
  color: #606266;
  line-height: 34px;
  margin-bottom: 16px;
}
.rightTable > p {
  font-size: 14px;
  color: #606266;
  line-height: 34px;
}
.replyBox .listBox {
  height: 160px;
  overflow: auto;
  border: 1px solid #e4e7ed;
  padding: 5px;
  margin-top: 20px;
}
.replyBoxFooter {
  margin-top: 14px;
}
.picBox {
  /* background-color: pink; */
  height: 360px;
  overflow-y: auto;
}
.contentPicBox {
  /* background-color: pink; */
  height: 260px;
  overflow-y: auto;
}
.leftTable {
  width: 100%;
  flex: none;
  margin-top: 44px;
}
.rightTable {
  flex: 0.4;
  margin: 10px;
}
.drawerFooter {
  height: 50px;
  position: relative;
}
.drawerFooterBtn {
  position: absolute;
  right: 50px;
  bottom: 10px;
}
</style>

<style>
.drawer-self {
  overflow-y: auto;
}
.el-image-viewer__wrapper {
  z-index: 3000 !important;
}
</style>
